// Balanced filter drawer fix - keep drawer open but allow filtering
(function() {
  // Global state tracking
  window._filterDrawerState = {
    filteringInProgress: false,
    allowFiltering: true
  };
  
  // Function to apply our fix
  function applyBalancedFix() {
    console.log('Applying balanced filter drawer fix...');
    
    // Get the drawer element
    const drawer = document.getElementById('hdt-filter_form');
    if (!drawer) {
      console.log('Filter drawer not found, will try again later');
      return false;
    }
    
    console.log('Found filter drawer, applying balanced fix');
    
    // APPROACH 1: OVERRIDE ONLY THE CLOSE METHOD
    try {
      // Find the drawer close method through prototype chain
      const protoChain = [];
      let currentProto = drawer.__proto__;
      
      // Build prototype chain
      while (currentProto && currentProto !== Object.prototype) {
        protoChain.push(currentProto);
        currentProto = currentProto.__proto__;
      }
      
      // Add constructor prototype
      if (drawer.constructor && drawer.constructor.prototype) {
        protoChain.push(drawer.constructor.prototype);
      }
      
      // Add the instance itself
      protoChain.unshift(drawer);
      
      // Override close methods in all prototypes
      protoChain.forEach(proto => {
        if (proto.close) {
          const originalClose = proto.close;
          proto.close = function(event) {
            // Only block automatic closing during filtering
            if (window._filterDrawerState.filteringInProgress) {
              console.log('Preventing drawer close during filtering');
              return false;
            }
            
            // Don't close if it's a checkbox or filter interaction
            if (event && event.target) {
              const isCheckbox = event.target.type === 'checkbox';
              const isFilterGroup = event.target.closest('.hdt-filter-group') !== null;
              const isFilterForm = event.target.closest('form#hdt-facet-filters-form') !== null;
              
              if (isCheckbox || isFilterGroup || isFilterForm) {
                console.log('Preventing drawer close from filter element');
                return false;
              }
              
              // Only allow explicit close button or outside click
              const isCloseButton = event.target.getAttribute && 
                                   event.target.getAttribute('part') === 'close-button';
              const isOutsideClick = !drawer.contains(event.target);
              
              if (!isCloseButton && !isOutsideClick) {
                console.log('Preventing drawer close - not close action');
                return false;
              }
            }
            
            console.log('Allowing legitimate close request');
            return originalClose.apply(this, arguments);
          };
          console.log('Overrode close method successfully');
        }
      });
    } catch (err) {
      console.error('Error in close override:', err);
    }
    
    // APPROACH 2: CHECKBOX MONITORING WITHOUT STOPPING PROPAGATION
    try {
      const monitorCheckboxes = function() {
        const checkboxes = drawer.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
          // Skip if already monitored
          if (checkbox.hasAttribute('data-monitored')) return;
          
          // Mark as monitored to avoid duplicates
          checkbox.setAttribute('data-monitored', 'true');
          
          // Add event listeners that DON'T stop propagation
          checkbox.addEventListener('click', function(e) {
            console.log('Checkbox clicked, marking filtering in progress');
            window._filterDrawerState.filteringInProgress = true;
            
            // Allow filtering to work by NOT stopping propagation
            
            // Reset the flag after filtering completes
            setTimeout(() => {
              window._filterDrawerState.filteringInProgress = false;
            }, 1000);
          }, true);
          
          checkbox.addEventListener('change', function(e) {
            console.log('Checkbox changed, marking filtering in progress');
            window._filterDrawerState.filteringInProgress = true;
            
            // Reset the flag after filtering completes
            setTimeout(() => {
              window._filterDrawerState.filteringInProgress = false;
            }, 1000);
          }, true);
        });
        console.log(`Monitored ${checkboxes.length} checkboxes`);
      };
      
      // Initial monitoring
      monitorCheckboxes();
      
      // Set up observer for new checkboxes
      const formArea = drawer.querySelector('form#hdt-facet-filters-form');
      if (formArea) {
        const observer = new MutationObserver(() => {
          monitorCheckboxes();
        });
        
        observer.observe(formArea, {
          childList: true,
          subtree: true
        });
      }
    } catch (err) {
      console.error('Error in checkbox monitoring:', err);
    }
    
    // APPROACH 3: TRACK ACTIVE FILTERS WITHOUT STOPPING EVENTS
    try {
      const monitorActiveFilters = function() {
        const activeFilters = document.querySelectorAll('.hdt-active-filters__remove, .hdt-active-filters__clear-all, wrapp-hdt-facet-url a');
        
        activeFilters.forEach(filter => {
          // Skip if already monitored
          if (filter.hasAttribute('data-monitored')) return;
          
          // Mark as monitored
          filter.setAttribute('data-monitored', 'true');
          
          // Add event listeners that DON'T stop propagation
          filter.addEventListener('click', function(e) {
            console.log('Active filter clicked, marking filtering in progress');
            window._filterDrawerState.filteringInProgress = true;
            
            // Reset the flag after filtering completes
            setTimeout(() => {
              window._filterDrawerState.filteringInProgress = false;
            }, 1000);
          }, true);
        });
      };
      
      // Initial monitoring
      monitorActiveFilters();
      
      // Set up observer for new active filters
      const activeFiltersObserver = new MutationObserver(() => {
        monitorActiveFilters();
      });
      
      activeFiltersObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (err) {
      console.error('Error in active filter monitoring:', err);
    }
    
    // APPROACH 4: FORM SUBMIT HANDLER - CRITICAL FOR FILTERING
    try {
      const filterForm = drawer.querySelector('form#hdt-facet-filters-form');
      if (filterForm) {
        // Ensure form submissions work
        filterForm.addEventListener('change', function(e) {
          console.log('Form change detected, allowing filtering to proceed');
          
          // Mark filtering in progress
          window._filterDrawerState.filteringInProgress = true;
          
          // IMPORTANT: Let the event propagate to allow filtering to work!
          
          // Reset after filtering completes
          setTimeout(() => {
            window._filterDrawerState.filteringInProgress = false;
          }, 1000);
        }, true);
      }
    } catch (err) {
      console.error('Error in form handling:', err);
    }
    
    // Add classes for potential CSS hooks
    drawer.classList.add('filter-drawer-fixed');
    
    console.log('Balanced filter drawer fix applied successfully');
    return true;
  }
  
  // Try to apply the fix immediately
  let fixApplied = applyBalancedFix();
  
  // Keep trying until successful
  if (!fixApplied) {
    const fixInterval = setInterval(() => {
      fixApplied = applyBalancedFix();
      if (fixApplied) {
        clearInterval(fixInterval);
      }
    }, 500);
  }
  
  // Also apply on DOM load
  document.addEventListener('DOMContentLoaded', function() {
    applyBalancedFix();
  });
  
  // Reapply after filter events
  document.addEventListener('facet:render', function() {
    console.log('Facet render detected, reapplying fix');
    setTimeout(applyBalancedFix, 200);
  });
  
  // Listen for product updates
  document.addEventListener('products:update', function() {
    console.log('Products update detected, reapplying fix');
    setTimeout(applyBalancedFix, 200);
  });
  
  // Try multiple times with delays
  setTimeout(applyBalancedFix, 500);
  setTimeout(applyBalancedFix, 1000);
  setTimeout(applyBalancedFix, 2000);
})();
